import React from 'react';

import { SocialMediaType } from '../../enums/socialMediaType.enum';

import FbIconDark from './images/dark/fb.svg';
import YoutubeIconDark from './images/dark/youtube.svg';
import LinkedInIconDark from './images/dark/linkedin.svg';
import XIconDark from './images/dark/x.svg';
import InstagramIconDark from './images/dark/instagram.svg';
import TikTokIconDark from './images/dark/tiktok.svg';


import FbIcon from './images/light/fb.svg';
import YoutubeIcon from './images/light/youtube.svg';
import LinkedInIcon from './images/light/linkedin.svg';
import XIcon from './images/light/x.svg';
import InstagramIcon from './images/light/instagram.svg';
import TikTokIcon from './images/light/tiktok.svg';

import { SocialIcon } from './socialMediaIcon.styled';
import { SocialMediaIconsData } from './socialMediaIcon.types';

export const SocialMediaIcon: React.FC<SocialMediaIconsData> = (data: SocialMediaIconsData) => {
  const { type, theme = 'dark' } = data;

  const getSocialMediaIcon = (socialMediaType: SocialMediaType) => {
    switch (socialMediaType) {
      case SocialMediaType.Facebook:
        return theme === 'light' ? FbIcon : FbIconDark;
      case SocialMediaType.Youtube:
        return theme === 'light' ? YoutubeIcon : YoutubeIconDark;
      case SocialMediaType.LinkedIn:
        return theme === 'light' ? LinkedInIcon : LinkedInIconDark;
      case SocialMediaType.X:
        return theme === 'light' ? XIcon : XIconDark;
      case SocialMediaType.Instagram:
        return theme === 'light' ? InstagramIcon : InstagramIconDark;
      case SocialMediaType.TikTok:
        return theme === 'light' ? TikTokIcon : TikTokIconDark;
    }
  };

  return (
    <SocialIcon src={getSocialMediaIcon(type)} alt={type} />
  );
}
